export const PORTAL_URLS = {
    scholarship: {
        prod: "https://scholarships.gyandiksha.in",
        dev: "http://localhost:5174",
    },
    skillPassport: {
        prod: "https://skills.gyandiksha.in",
        dev: "http://localhost:5175",
    },
    studentManagement: {
        prod: "https://management.gyandiksha.in",
        dev: "http://localhost:5176",
    },
    staffAttendance: {
        prod: "https://staff-attendance.gyandiksha.in",
        dev: "http://localhost:5177",
    },
    attendance: {
        prod: "https://student-attendance.gyandiksha.in",
        dev: "http://localhost:5178",
    },
    placementManagement: {
        prod: "https://placements.gyandiksha.in",
        dev: "http://localhost:5179",
    },
};